import { Ban, Mic2, FileText, Crown, CreditCard, Wand2, Languages, Bot, Volume2, UserPlus } from "lucide-react";
import { Badge } from "../ui/badge";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "./dialog"
import UploadSection from "../dashboard/uploadsection"
import { CreditStatus, UpgradeButton } from "../dashboard/creditstatus";
import NoiseRemovalCard from "./noiseremovalcard";

const Dashboard = () => {
  return (
    <div className="p-8 lg:p-12 bg-[#f8fafc] dark:bg-[#0f172a] min-h-screen">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 mt-6 lg:mb-20 lg:mt-8">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-medium text-gray-800 dark:text-gray-100 tracking-tight leading-[1.2] mb-4">
            Generative<br />
            speech to speech<br />
            translation
          </h1>
          <p className="text-lg sm:text-xl text-gray-600 dark:text-gray-400">
            Automated AI dubbing when quality matters
          </p>
        </div>

        {/* Mobile-only credit and pro section */}
        <div className="lg:hidden space-y-4 mb-8">
          <CreditStatus/>
          <UpgradeButton/>
        </div>

        <div className="flex items-center justify-between mb-8 lg:mb-12">
          <h2 className="text-2xl sm:text-3xl font-medium text-gray-800 dark:text-gray-100">
            What do you want to do?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-16 lg:mb-24">
          {/* Audio Enhancement Card */}
          <Dialog>
            <DialogTrigger asChild>
              <div className="bg-white dark:bg-[#1e293b]/60 rounded-3xl p-6 sm:p-8 lg:p-10 border-2 border-gray-300 dark:border-gray-700 hover:border-gray-400 dark:hover:border-gray-600 transition-colors min-h-[350px] lg:min-h-[400px] cursor-pointer">
                <div className="flex items-center justify-between mb-6 lg:mb-8">
                  <div className="w-12 h-12 lg:w-16 lg:h-16 bg-purple-50 dark:bg-purple-500/10 rounded-full flex items-center justify-center">
                    <Wand2 className="w-6 h-6 lg:w-8 lg:h-8 text-purple-500" />
                  </div>
                  <Badge className="bg-blue-400 hover:bg-blue-500 text-white px-3 py-1 lg:px-4 lg:py-1.5 text-sm lg:text-base">
                    Try it now
                  </Badge>
                </div>
                <h3 className="text-xl sm:text-2xl font-medium text-gray-800 dark:text-gray-100 mb-3 lg:mb-4">
                  Audio Enhancement
                </h3>
                <p className="text-base sm:text-lg lg:text-[19px] leading-relaxed text-gray-600 dark:text-gray-400">
                  Upload your audio and let our AI automatically remove filler words, background noise, and unwanted sounds. Get crystal-clear, professional-quality audio with perfect pacing and flow.
                </p>
              </div>
            </DialogTrigger>
            <DialogContent className="sm:max-w-[600px]">
              <DialogHeader>
                <DialogTitle className="sr-only">Audio Enhancement</DialogTitle>
                <DialogDescription className="sr-only">
                  Upload your audio file for enhancement
                </DialogDescription>
              </DialogHeader>
              <UploadSection />
            </DialogContent>
          </Dialog>

          <NoiseRemovalCard/>

   {/* Text to Speech Card */}
   <Link to={'/tts'}>
            <div className="bg-white dark:bg-[#1e293b]/60 rounded-3xl p-6 sm:p-8 lg:p-10 border-2 border-gray-300 dark:border-gray-700 hover:border-gray-400 dark:hover:border-gray-600 transition-colors min-h-[350px] lg:min-h-[400px]">
              <div className="flex items-center justify-between mb-6 lg:mb-8">
                <div className="w-12 h-12 lg:w-16 lg:h-16 bg-pink-50 dark:bg-pink-500/10 rounded-full flex items-center justify-center">
                  <Volume2 className="w-6 h-6 lg:w-8 lg:h-8 text-pink-500" />
                </div>
                <Badge className="bg-blue-400 hover:bg-blue-500 text-white px-3 py-1 lg:px-4 lg:py-1.5 text-sm lg:text-base">
                  Try it now
                </Badge>
              </div>
              <h3 className="text-xl sm:text-2xl font-medium text-gray-800 dark:text-gray-100 mb-3 lg:mb-4">Text to Speech</h3>
              <p className="text-base sm:text-lg lg:text-[19px] leading-relaxed text-gray-600 dark:text-gray-400">
                Convert any text into lifelike speech with our advanced AI voices. Choose from a variety of natural-sounding voices or use your custom voice clone for perfectly matched audio content.
              </p>
            </div>
          </Link>




          <div className="bg-white dark:bg-[#1e293b]/60 rounded-3xl p-10 border-2 border-gray-300 dark:border-gray-700 hover:border-gray-400 dark:hover:border-gray-600 transition-colors min-h-[400px]">
            <div className="flex items-center justify-between mb-8">
              <div className="w-16 h-16 bg-blue-50 dark:bg-blue-500/10 rounded-full flex items-center justify-center">
                <Mic2 className="w-8 h-8 text-blue-500" />
              </div>
              <Badge variant="secondary" className="font-normal text-base">Launching Soon</Badge>
            </div>
            <h3 className="text-2xl font-medium text-gray-800 dark:text-gray-100 mb-4">Voice Clone</h3>
            <p className="text-[19px] leading-relaxed text-gray-600 dark:text-gray-400">
              Create perfect voice clones and custom voices for your content. Our advanced AI technology captures the essence of any voice, enabling natural-sounding speech synthesis with precise control over tone and style.
            </p>
          </div>

          {/* AI Translation Hub Card */}
          <div className="bg-white dark:bg-[#1e293b]/60 rounded-3xl p-10 border-2 border-gray-300 dark:border-gray-700 hover:border-gray-400 dark:hover:border-gray-600 transition-colors min-h-[400px]">
            <div className="flex items-center justify-between mb-8">
              <div className="w-16 h-16 bg-orange-50 dark:bg-orange-500/10 rounded-full flex items-center justify-center">
                <Languages className="w-8 h-8 text-orange-500" />
              </div>
              <Badge variant="secondary" className="font-normal text-base">Launching Soon</Badge>
            </div>
            <h3 className="text-2xl font-medium text-gray-800 dark:text-gray-100 mb-4">AI Translation Hub</h3>
            <p className="text-[19px] leading-relaxed text-gray-600 dark:text-gray-400">
              Transform your content with AI-powered translation and dubbing. Seamlessly convert speech and text between languages while preserving the original emotion and context of your message.
            </p>
          </div>

          {/* AI Agents Card */}
          <div className="bg-white dark:bg-[#1e293b]/60 rounded-3xl p-10 border-2 border-gray-300 dark:border-gray-700 hover:border-gray-400 dark:hover:border-gray-600 transition-colors min-h-[400px]">
            <div className="flex items-center justify-between mb-8">
              <div className="w-16 h-16 bg-green-50 dark:bg-green-500/10 rounded-full flex items-center justify-center">
                <Bot className="w-8 h-8 text-green-500" />
              </div>
              <Badge variant="secondary" className="font-normal text-base">Coming Soon</Badge>
            </div>
            <h3 className="text-2xl font-medium text-gray-800 dark:text-gray-100 mb-4">AI Agents</h3>
            <p className="text-[19px] leading-relaxed text-gray-600 dark:text-gray-400">
              Deploy intelligent AI agents that can interact with your audience using natural language. Create engaging conversational experiences with customizable personalities and knowledge bases.
            </p>
          </div>

          {/* Custom Voices Card */}
          <div className="bg-white dark:bg-[#1e293b]/60 rounded-3xl p-10 border-2 border-gray-300 dark:border-gray-700 hover:border-gray-400 dark:hover:border-gray-600 transition-colors min-h-[400px]">
            <div className="flex items-center justify-between mb-8">
              <div className="w-16 h-16 bg-yellow-50 dark:bg-yellow-500/10 rounded-full flex items-center justify-center">
                <UserPlus className="w-8 h-8 text-yellow-500" />
              </div>
              <Badge variant="secondary" className="font-normal text-base">Coming Soon</Badge>
            </div>
            <h3 className="text-2xl font-medium text-gray-800 dark:text-gray-100 mb-4">Custom Voices</h3>
            <p className="text-[19px] leading-relaxed text-gray-600 dark:text-gray-400">
              Build your own voice library with personalized AI voices. Create unique voice identities for your brand or project, complete with customizable accents, emotions, and speaking styles.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;